export default __webpack_public_path__ + "static/media/profile-close.8b2c42f1.svg";